export default "__VITE_ASSET__CS24kWOs__"